import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Menu } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import ExportUserRightsDetailsAction from './ExportUserRightsDetailsAction';
import { SECURITY_LIST_IMPORTED } from '../../../subscriptions';
import { useToast } from 'hooks/toasts/useToast';
import ExportAction from './ExportAction';
import ImportAction from './ImportAction';
import { useApolloClient } from '@apollo/client';
import { useSubscription } from 'hooks/apollo';
import { MenuItemWithAction } from 'components/menu/MenuWithActionsStyle';
import { IconButton } from '@totalsoft/rocket-ui';

const AuthorizationActions = () => {
  const [t] = useTranslation();
  const addToast = useToast();
  const client = useApolloClient();
  const [saving, setSaving] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  /* Handlers */

  const handleClose = () => setMenuAnchorEl(null);

  const handleClick = event => setMenuAnchorEl(event.target);

  /* End Handlers */

  /* Subscriptions */

  useSubscription(SECURITY_LIST_IMPORTED, {
    onData: _ => {
      setSaving(false);
      addToast(t('Authorization.SecurityListImported'), 'success');
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'pagedAuthorizations' });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'authorizationWithRefines' });
      client.cache.gc();
    }
  });

  /* End Subscriptions */

  const AuthorizationActions = useMemo(
    () => [
      {
        component: <ImportAction saving={saving} setSaving={setSaving} />,
        visible: true
      },
      {
        component: <ExportAction saving={saving} setSaving={setSaving} />,
        visible: true
      },
      {
        component: <ExportUserRightsDetailsAction saving={saving} setSaving={setSaving} />,
        visible: true
      }
    ],
    [saving, setSaving]
  );

  return (
    <>
      <Tooltip placement='top' title={t('ShowMore')}>
        <div ref={menuAnchorEl}>
          <IconButton color='primary' onClick={handleClick}>
            <MoreHoriz fontSize={'small'} />
          </IconButton>
        </div>
      </Tooltip>
      <Menu
        id='visible-fields-menu'
        anchorEl={menuAnchorEl}
        getContentAnchorEl={null}
        open={Boolean(menuAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        MenuListProps={{
          disablePadding: true
        }}
      >
        {AuthorizationActions.filter(x => x.visible).map((action, idx) => (
          <MenuItemWithAction key={idx}>{action.component}</MenuItemWithAction>
        ))}
      </Menu>
    </>
  );
};

export default AuthorizationActions;
